import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm, usePage } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import OnboardingStepForm from './OnboardingStepForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import { computed } from 'vue';
    import { OnboardingStep, SharedData } from '@/types';
    import type { Table } from '@tanstack/vue-table';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateOnboardingStep',
  props: {
    table: {}
  },
  setup(__props: any) {

    

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const form = useForm({
        service: '',
        other_title: '',
        description: '',
        allow_comments: false,
        allow_files: false,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.onboarding.store', { company: selectedCompanyId.value }),
    "query-key": [_unref(QueryKey).ONBOARDING, selectedCompanyId.value],
    title: "onboarding.create_step",
    "button-text": "onboarding.create_step"
  }, {
    default: _withCtx(() => [
      _createVNode(OnboardingStepForm, {
        form: _unref(form),
        table: _ctx.table
      }, null, 8, ["form", "table"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})